module.exports = __webpack_public_path__ + "img/web_04.cee68643.png";